import './Checkout.css';
import React, { useContext, useEffect, useState } from 'react';
import { CartContext } from '../../store/CartContext';

import { VALIDATION_SCHEMA } from '../../helpers/checkout-validation-schema';
import { getApiKeys, getDemoKeys, getPaymentBody } from '../../helpers/checkout-helpers';
import { GenerateFields } from '../../components/checkout/CheckoutInput';
import CheckoutWrapper from '../../components/checkout/CheckoutWrapper';
import { CheckoutContext } from '../../store/CheckoutContext';
import {
  CHECKOUT_FORM_DEFAULT_STATE,
  CHECKOUT_FORM_DEMO_CHALLENGE_DECLINE_DEFAULT_STATE,
  CHECKOUT_FORM_DEMO_CHALLENGE_SUCCESS_DEFAULT_STATE,
  CHECKOUT_FORM_DEMO_DEFAULT_STATE,
} from '../../helpers/checkout-constants';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { eligibility } from '../../helpers/checkout-api';

interface Props {}

const CheckoutHostedFields: React.FC<Props> = props => {
  const { cart } = useContext(CartContext);
  const { environment, setLoading } = useContext(CheckoutContext);

  const location = useLocation();

  const [orderId] = useState<string>(uuidv4());

  const getDefaultState = () => {
    if (!location.pathname.includes('demo')) {
      return CHECKOUT_FORM_DEFAULT_STATE;
    }

    if (location.pathname.includes('challenge-success')) {
      return CHECKOUT_FORM_DEMO_CHALLENGE_SUCCESS_DEFAULT_STATE;
    }

    if (location.pathname.includes('challenge-decline')) {
      return CHECKOUT_FORM_DEMO_CHALLENGE_DECLINE_DEFAULT_STATE;
    }

    return CHECKOUT_FORM_DEMO_DEFAULT_STATE;
  };

  const [state, setState] = useState<{ [key: string]: any }>({
    transactionAmount:
      cart?.reduce((total, cartItem) => total + cartItem.quantity * cartItem.item.price, 0).toFixed(2) || 0,
    ...getDefaultState(),
    mid: localStorage.getItem('mid') || '',
  });

  useEffect(() => {
    let keys: { spreedlyKey: string; appKey: string; appSecret: string; mid?: string } = getApiKeys();

    if (location.pathname.includes('demo') && (!keys.appKey || !keys.appSecret || !keys.spreedlyKey)) {
      keys = getDemoKeys();
    }

    if (keys?.appKey?.length > 0 || keys?.appSecret.length > 0 || keys?.spreedlyKey.length > 0) {
      setState({
        ...state,
        appKey: keys?.appKey,
        appSecret: keys?.appSecret,
        spreedlyKey: keys?.spreedlyKey,
        mid: keys?.mid,
      });
    }
  }, []);

  async function paymentHandler() {
    if ((window as any).UIWidget) {
      const body = getPaymentBody(state, cart, environment, orderId);
      (window as any).fc.setOrderId({ orderId: orderId });

      if (state?.state) {
        // @ts-ignore
        body.billingInformation.state = state?.state;
      }

      if (state?.saveAddress) {
        // @ts-ignore
        body.billingInformation = { ...body.billingInformation };
      }

      localStorage.setItem('state', JSON.stringify(state));
      localStorage.setItem('cart', JSON.stringify(cart));
      // console.log('JSON.stringify(body)', JSON.stringify(body));

      const transactionName = state.responseCode === 100 || state.responseCode === '100' ? 'eligibility' : 'evaluate';
      eligibility(body, environment, transactionName);
      setTimeout(() => setLoading(false), 3000);

      const urls: any = {};
      ['successUrl', 'rejectUrl', 'cancelUrl'].forEach(el => {
        if (state[el] && state[el]?.length > 10) {
          // @ts-ignore
          urls[el] = state[el];
        }
      });
      const flow: { ConsentFlowConfiguration?: number } = {};

      if (location.pathname.includes('demo')) {
        flow.ConsentFlowConfiguration = 1;
        urls.successUrl = `${process.env.PUBLIC_URL}/demo/success`;
        urls.rejectUrl = `${process.env.PUBLIC_URL}/demo/decline`;
      }

      if (location.pathname === '/demo/iframe/consent/') {
        flow.ConsentFlowConfiguration = 2;
      }

      (window as any).UIWidget.InitUi({ orderId: body.OrderId, ...urls, ...flow });

      // const options = {
      //   method: 'POST',
      //   // mode: 'cors',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Access-Control-Allow-Origin': '*',
      //   },
      //   body: JSON.stringify(body),
      //   // credentials: 'include',
      // };

      // @ts-ignore
      // fetch(url, options)
      //   .then(res => res.json())
      //   .then(res => {
      //     if (res.statusCode !== null && res.statusCode !== 200 && res.statusCode !== 201) {
      //       // @ts-ignore
      //       const errors = { code: res?.statusCode || 'Unknown', message: res?.message || 'Payment error' };
      //       setPaymentErrors(errors);
      //       setLoading(false);
      //     } else {
      //       setLoading(false);
      //       if (res.transmitId) {
      //         if (window.location.pathname === '/iframe/') {
      //           // eslint-disable-next-line no-restricted-globals
      //           parent.postMessage('success', '*');
      //         } else {
      //           navigate('/success');
      //         }
      //         return;
      //       }
      //       switch (res.result) {
      //         case 'NOT_ELIGIBLE':
      //         case 'DECLINED':
      //         case 'ORDER_DECLINED':
      //           console.log('window.location.pathname++++', window.location.pathname);
      //           if (window.location.pathname.includes('/demo/iframe/')) {
      //             // eslint-disable-next-line no-restricted-globals
      //             parent.postMessage('decline-iframe', '*');
      //           } else if (window.location.pathname === '/iframe/') {
      //             // eslint-disable-next-line no-restricted-globals
      //             parent.postMessage('decline', '*');
      //           } else {
      //             navigate('/decline');
      //           }
      //           // window &&
      //           //   window.top &&
      //           //   window.top.location &&
      //           //   (window.top.location.href = `${window.location.origin}/decline`);
      //           break;
      //         default:
      //           const urls: any = {};
      //           ['successUrl', 'rejectUrl', 'cancelUrl'].forEach(el => {
      //             if (state[el] && state[el]?.length > 10) {
      //               // @ts-ignore
      //               urls[el] = state[el];
      //             }
      //           });
      //           const flow: { ConsentFlowConfiguration?: number } = {};
      //
      //           if (location.pathname.includes('demo')) {
      //             flow.ConsentFlowConfiguration = 2;
      //             urls.successUrl = `${process.env.PUBLIC_URL}/demo/success`;
      //             urls.rejectUrl = `${process.env.PUBLIC_URL}/demo/decline`;
      //
      //             // process.env.PUBLIC_URL
      //           }
      //
      //           if (location.pathname === '/demo/iframe/no-consent/') {
      //             flow.ConsentFlowConfiguration = 1;
      //           }
      //
      //           (window as any).UIWidget.InitUi({ ...res, externalOrderId: body.OrderId, ...urls, ...flow });
      //       }
      //     }
      //   })
      //   .catch(e => {
      //     const errors = { code: e.statusCode || 'Unknown', message: e.message || 'Payment error' };
      //     setPaymentErrors(errors);
      //     setLoading(false);
      //     // window &&
      //     //   window.top &&
      //     //   window.top.location &&
      //     //   (window.top.location.href = `${window.location.origin}/decline`);
      //   });
    }
  }

  return (
    <CheckoutWrapper
      paymentElement={<GenerateFields state={state} setState={setState} fieldName={'paymentMethod'} />}
      validationSchema={VALIDATION_SCHEMA}
      paymentHandler={paymentHandler}
      state={state}
      setState={setState}
    />
  );
};

export default CheckoutHostedFields;
